import type { ICellRendererComp, ICellRendererParams } from 'ag-grid-community';
import type { LPSettlementReportBlotterRow } from '../UnsettledTransactions/blotter/lpSettlementReportRow';

/**
 * Class-based vanilla JavaScript cell renderer for TradeID.
 * Bypasses React rendering for maximum performance during sorting and scrolling, because
 * the React-rendering was flickering on sorting.
 */
export class TradeIDCell implements ICellRendererComp<LPSettlementReportBlotterRow> {
  private eGui!: HTMLElement;

  init(params: ICellRendererParams<LPSettlementReportBlotterRow>): void {
    this.eGui = document.createElement('div');
    this.eGui.className = 'ag-cell-value';
    this.setValue(params);
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  refresh(params: ICellRendererParams<LPSettlementReportBlotterRow>): boolean {
    this.setValue(params);
    return true;
  }

  private setValue(params: ICellRendererParams<LPSettlementReportBlotterRow>): void {
    const { value, colDef } = params;

    if (colDef?.showRowGroup) {
      this.eGui.textContent = 'Trade';
      return;
    }

    this.eGui.textContent = value ?? '';
    this.eGui.title = value ?? '';
  }
}
